import { initializeApp } from 'firebase/app';
import { Messaging, getMessaging, getToken } from "firebase/messaging";
import store from "../redux/store";
import { FCM_TOKEN } from "../data/local-storage-constants";
import { addNewNotification, registerFCMToken } from "../redux/slices";
import { ToastNotifyError, ToastNotifyInfo, ToastNotifySuccess } from "./toast-helper";
import { getLocalStorage, setLocalStorage } from "../utils";
import { NOTIFICATION_TYPES_TO_SHOW } from "../components/notifications";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const NOTIFICATION_TYPES = {
  PUSH: "PANEL_NOTIFICATION"
}

export enum NOTIFICATION_EVENT_TYPES {
  ONLINE_ORDER_RECONCILIATION_NOTIFICATION = 'ONLINE_ORDER_RECONCILIATION_NOTIFICATION'
}

async function requestPermissionAndFCM(messaging: Messaging, vapidKey: string) {
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    try {
      if (getLocalStorage(FCM_TOKEN)) {
        return; // Don't create again;
      }
      // Get FCM token
      const fcmToken = await getToken(messaging, { vapidKey });
      if (fcmToken) {
        setLocalStorage(FCM_TOKEN, fcmToken);
        return fcmToken;
      } else {
        console.warn('No registration token available. Request permission to generate one.');
        return;
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
      return;
    }
  } else {
    console.warn('Permission denied. Push notifications will not work.');
    return;
  }
}
/** called after login */
export function registerFCM() {
  const fcmToken = localStorage.getItem(FCM_TOKEN);
  if (!fcmToken) { console.log('no token created') };
  store.dispatch(registerFCMToken({ fcmToken }));
}

export function serviceWorkerSetup() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
      });

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === NOTIFICATION_TYPES.PUSH) {
        const { data } = event?.data?.payload;
        const details = JSON.parse(data.event || "{}");
        handlePushNotifications(details, data.title, data.message);
      }
    });
  }
}

export function firebaseSetup() {
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  requestPermissionAndFCM(messaging, process.env.REACT_APP_VAPID_KEY || "");
}

function handlePushNotifications(notificationData: { type: string; data: any }, title: string, message: string) {
  // show notification dot icon
  const { data, type } = notificationData;
  if (NOTIFICATION_TYPES_TO_SHOW.includes(type)) {
    store.dispatch(addNewNotification(data));
  }
  // handle info toast depending on type
  switch (type) {
    case NOTIFICATION_EVENT_TYPES.ONLINE_ORDER_RECONCILIATION_NOTIFICATION:
      if (data.status === 'COMPLETED') {
        ToastNotifySuccess(message);
      }
      else
        ToastNotifyError(message);
  }
}